<div class="wrapper">
  <section
    class="sticky top-0 z-10 flex justify-between items-center bg-white border-2 border-b-indigo-800"
  >
    <h2 class="flex-1" matDialogTitle>{{ data.ppa.name }} Reviews</h2>
    <button
      class="mx-5"
      type="button"
      mat-icon-button
      (click)="close()"
      title="Close dialog"
    >
      <mat-icon fontIcon="close" aria-label="close icon"></mat-icon>
    </button>
  </section>

  <!--
    1. Card cause you can like a review, or even reply to it.
    2. We should display the age of the review, easier to digest.
    -->
  <section details-section class="flex-1 flex flex-col gap-4 p-3 overflow-auto">
    
        <!-- TODO: try to make the "REVIEWS" headers stick to the top -->
      <h5 class="font-bold">REVIEWS</h5>
      <mat-card *ngFor="let review of data.ppa.Reviews">

        <!-- @todo: make review card a component -->
        <mat-card-header>
          <mat-card-subtitle>
            Review by {{ review.CorpMember?.nickname ?? review.CorpMember?.first_name }} ({{ review._age }},
            {{ review.created_at | date : 'd/M/yy' }})</mat-card-subtitle
          >
        </mat-card-header>
        <mat-card-content>
          {{ review.comment }}
          <br *ngIf="review.comment" />
          <div class="start-rating-div" *ngIf="review.star_rating">
            <mat-icon
              class="w-5 h-5 text-xl"
              *ngFor="let star of starCountArray(review.star_rating)"
              [fontIcon]="star ? 'star' : 'star_border'"
              aria-label="star icon"
              color="secondary"
            ></mat-icon>
          </div>
        </mat-card-content>
      </mat-card>
    
  </section>
</div>
